import script from "./MenuBottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBottomBar.vue?vue&type=script&setup=true&lang=js"

import "./MenuBottomBar.vue?vue&type=style&index=0&id=6fda1939&lang=css"

const __exports__ = script;

export default __exports__